module.exports = {
  footerText: 'Copyright SSA Soft © 2001',
}
